<template>
  <div class="live-wrapper df fdc aic f1 w100p">

    <!-- SPLASH -->
    <div class="live-splash df aic w100p">
      <div class="live-cupping-video df fdc jcsb">
        <iframe :width="videoWidth()" :height="videoHeight()" src="https://www.youtube.com/embed/EnyvObOZQCs" frameborder="0" allowfullscreen></iframe>
      </div>
      <div class="live-cupping-top f1 df fdc">
        <div class="live-cupping-top-below df jcsb f1">
          <div class="live-cupping-questions df fdc f2">
            <h4>Viewer Questions</h4>
            <div class="live-qupping-questions-list f1">
              <div class="user-question df fdr" v-for="(question, i) in liveQuestions">
                <img src="../../static/images/question.png" class="icon">
                <p class="viewer-question-text">
                  ({{question.name}}, {{question.location}}) {{question.question}} <span class="dif">
                    +{{Object.keys(question.plusOnes).length}}
                    <i class="fa fa-thumbs-up question-plus-one" v-bind:class="{
                    'my-plus-one': $store.getters['AUTH.uid'] && question.plusOnes && question.plusOnes[$store.getters['AUTH.uid']]
                  }"></i>
                  </span>
                </p>
              </div>
            </div>
            <div class="ask-a-question df fdc">
              <!-- <p>Ask a question</p> -->
              <div class="df f100p jcsb aic">
                <input class="ask-a-question-input f1" placeholder="Ask a question" type="text"/>
                <button class="ask-a-question-button">Go</button>
              </div>
            </div>
          </div>
      <!--     <div class="cupping-steps df fdc f1">
            <div class="df aic jcsb cupping-top">
              <div class="step-description f1 df aic jcsb">
                <p class="cupping-with">Cupping with Tony "Tonx" Konecny</p>
              </div>
            </div>
            <div  v-for="(step, i) in cuppingSteps"
                  class="cupping-step1 df jcsb w100p"
                  v-bind:class="{
                  'current-step': currentStep === i
                }"
                @click="setCurrentStep(i)">


                <div class="step-wrap df fdc">
                  <div class="step-wrap-top df jcsb w100p">
                    <a class="cupping-step-name f1">{{i + 1}}. {{step.name}}</a>
                    <p class="cupping-step-arrow" v-if="currentStep === i">
                      ←
                    </p>
                  </div>
                  <div class="step-wrap-bottom">
                    <p class="step-description" v-if="currentStep === i">
                      {{cuppingSteps[currentStep].name}}: {{cuppingSteps[currentStep].instruction}}
                    </p>
                  </div>
                </div>



            </div>
            <br/>
          </div> -->
        </div>

        <!-- Flavor wheel test -->
        <!-- <FlavorWheel /> -->

      </div>
    </div>

    <!-- STEP DESCRIPTION -->
<!--     <div class="step-description f1 df fdc aic jcc w100p">
      <h2>
        {{cuppingSteps[currentStep].name}}
      </h2>
      <p>
        {{cuppingSteps[currentStep].instruction}}
      </p>
    </div> -->

    <div class="controls-and-description df jcfe w100p">
      <div class="df">
        <span class="sheet-option df aic">
          <input v-model="showAverageScores" type="checkbox" name="">
          <p>Show Average Scores</p>
        </span>
        <span class="sheet-option df aic">
          <input :checked="$store.getters['AUTH.colorMode']" @click="flipColorMode()" type="checkbox" name="">
          <p>Light Mode</p>
        </span>
<!--         <span class="sheet-option df aic">
          <input v-model="showHorizontalView" type="checkbox" name="">
          <p>Horizontal View</p>
        </span> -->
      </div>
    </div>




    <!-- SCORING CHART -->
    <div class="live-current-step w100p"
        v-bind:class="{
          'horizontal-scoring-view': showHorizontalView}">

<!-- 
        <div class="coffees df jcsb w100p">
          <div class="one-coffee fdc" v-for="(coffee, n) in coffees"
          v-bind:class="{
            'blue-bag': coffee.bag == 'blue',
            'green-bag': coffee.bag == 'green',
            'yellow-bag': coffee.bag == 'yellow',
            'orange-bag': coffee.bag == 'orange',
          }">
            <span class="one-coffee-bag df aic jcc">            
              <img :src="coffee.thumbnail"/>
              <p>
                {{coffee.name}}
              </p>
            </span>

          </div>
        </div>

        <div  class="cupping-step"
        v-for="(step, i) in cuppingSteps"
        v-if="step.scoring">
        </div> -->


      <VueSlickCarousel :slidesPerRow="smaller() ? 1 : 2" v-if="small()" class="coffees df jcsb w100p" :arrows="true" :dots="true">
        
        <div class="one-coffee" v-for="(coffee, n) in coffees"
        v-bind:class="{
          'blue-bag': coffee.bag == 'blue',
          'green-bag': coffee.bag == 'green',
          'yellow-bag': coffee.bag == 'yellow',
          'orange-bag': coffee.bag == 'orange',
        }">
          <p class="one-coffee-bag df aic jcsb"><span>{{coffee.name}}</span><span>{{coffeeScore(n)}}/30</span></p>


          <!-- /// -->
          <div class="coffee-my-things df fdc">

            <!-- CUPPING STEP START -->
            <div  class="cupping-step"
                  v-bind:class="{
                    'smaller-step': step.smallerDisplay 
                  }"
                  v-for="(step, i) in tastingTemplate.steps"
                  v-if="step.scoring">
                  

              <!-- Start of Step's Metrics -->
              <div class="one-score-metric df fdr" v-for="(metric, j) in step.metrics"
                      v-bind:class="{
                      'roast-level-vertical': metric.scoring.type == 'roast-level-vertical',
                      'scale-horizontal': metric.scoring.type == 'scale-horizontal',
                      'scale-vertical': metric.scoring.type == 'scale-vertical',
                      'descriptors-vertical': metric.scoring.type == 'descriptors-vertical',
                    }">

                <!-- Step dropdown bar -->
               <!--  <div class="step-title df jcsb aic w100p" v-if="n === 0 && j === 0" 
                  v-bind:class="{
                    'current-step-title': currentStep === i
                  }" @click="toggleShowStep(i)">
                  <h2>{{step.name}}</h2>
                  <p v-if="showSteps.indexOf(i) > -1">▲</p>
                  <p v-else>▼</p>
                </div> -->


                <div class="df fdc f1"
                        v-if="(showSteps.indexOf(i) > -1) || showHorizontalView">
                  <!-- Metric Name -->
                  <div class="one-score-title"
                        v-if="(showSteps.indexOf(i) > -1) || showHorizontalView">
                    <p>
                      {{metric.name}}
                    </p>
                  </div> 


                  <!-- Metric Type: scale-horizontal -->
                  <div class="one-score-select df aic w100p jcsb"
                        v-if="((showSteps.indexOf(i) > -1) || showHorizontalView) && (metric.scoring.type == 'scale-horizontal')">


                    <div class="bars df w100p jcsb">
                      
                      <div class="increment increment-down" @click="changeScoreValue(-0.1, metric.scoring.from, metric.scoring.to, [n, i, j])">
                        <p>
                          -
                        </p>
                      </div>

                      <div class="df fdc f1">
                        <div class="rating-bar group-rating">
                          <div class="bar-fill group-bar-fill" v-bind:style="{
                            width: Math.random()*100 + '%',
                            opacity: showAverageScores ? 0.6 : 0
                          }"></div>
                        </div>
                        <div class="rating-bar my-rating">
                            <vue-slider v-if="loaded" :width="'100%'"
                              :max="metric.scoring.to"
                              :min="metric.scoring.from"
                              :interval="metric.scoring.increment"
                              :style="{
                                'height': '12px',
                                'padding': 0
                              }"
                              :railStyle="{
                                'height': '12px',
                                'borderRadius': 0,
                                'backgroundColor': '#555'
                              }"
                              :stepStyle="{
                                'display': 'flex',
                                'backgroundColor': '#cacaca',
                                'borderRadius': 0,
                                'boxShadow': 'none',
                                'width': '1px'
                              }"
                              :processStyle="{
                                'backgroundColor': bagColor(coffee.bag),
                                'boxShadow': '#eeeeee',
                                'borderRadius': 0,
                              }"
                              :tooltipStyle="{
                                height: '25px',
                                width: '25px',
                                padding: 0,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }"
                              :dotOptions="{
                                tooltip: 'always'
                              }"
                              :dotStyle="{
                                display: 'none',
                                'borderRadius': 0,
                                'boxShadow': 'transparent',
                                'backgroundColor': 'transparent',
                                'borderColor': 'transparent',
                                'backgroundSize': 'contain',
                                'backgroundRepeat': 'no-repeat',
                                'backgroundPosition': 'center',
                                'height': '50px',
                                'width': '50px',
                                'top': '0',
                                'transform': 'translate(-17.5px, -65px)',
                              }"
                              :marks="staticMarksObject"
                              :markStyle="{
                                display: 'none',
                              }"
                              v-model="myScores[n].steps[i].metrics[j].score" />
                          <!-- <div class="bar-fill my-bar-fill" v-bind:style="{
                          width: Math.random()*100 + '%'
                        }"></div> -->
                        </div>
                        <!-- <div class="df jcsb w100p aic">
                          <a v-for="(score, j) in scoreCard">{{score}}</a>
                        </div> -->
                      </div>
                      <div class="increment increment-up"  @click="changeScoreValue(0.1, metric.scoring.from, metric.scoring.to, [n, i, j])">
                        <p>
                          +
                        </p>
                      </div>
                    </div>

                  </div> 
                </div>
                <!-- {{myScores}}     -->
                <!-- <input v-if="metric.scoring.scoreBox && ((showSteps.indexOf(i) > -1) || !showHorizontalView)" v-model="myScores[n].steps[i].metrics[j].score" class="metric-input" type="number" @input="checkInput($event, metric.scoring.from, metric.scoring.to, [n, i, j])" name="" :step="metric.scoring.increment" :min="metric.scoring.from" :max="metric.scoring.to"> -->



              </div>
              <!-- End of Step's Metrics -->




              <div class="descriptors df fdc" v-if="showSteps.indexOf(i) > -1">
                <h4>Descriptors</h4>
                <div class="df fdc">
                  <div class="word-cloud df aic jcc">
                    <vue-word-cloud
                        style="
                          height: 100px;
                          width: 100%;
                        "
                        :words="randomWordList()"
                        :color="'Grey'"
                        font-family="Roboto"
                      />
                  </div>
                  <div class="descriptor-list">
                    <p>
                      Earthy
                    </p>
                    <p>
                      Grape
                    </p>
                  </div>
                </div>
                <div class="df f100p jcsb aic descriptors-add">
                  <input placeholder="Add a descriptor" class="add-descriptor-input f1" type="text"/>
                  <button class="add-descriptor-button">Go</button>
                </div>
              </div>



            </div>
          </div>
          <!-- /// -->





        </div>
      </VueSlickCarousel>
      <div v-else class="coffees df jcsb w100p">
        <div class="one-coffee" v-for="(coffee, n) in coffees"
        v-bind:class="{
          'blue-bag': coffee.bag == 'blue',
          'green-bag': coffee.bag == 'green',
          'yellow-bag': coffee.bag == 'yellow',
          'orange-bag': coffee.bag == 'orange',
        }">
          <p class="one-coffee-bag df aic jcsb"><span>{{coffee.name}}</span><span>{{coffeeScore(n)}}/30</span></p>


          <!-- /// -->
          <div class="coffee-my-things df fdc">

            <!-- CUPPING STEP START -->
            <div  class="cupping-step"
                  v-bind:class="{
                    'smaller-step': step.smallerDisplay 
                  }"
                  v-for="(step, i) in tastingTemplate.steps"
                  v-if="step.scoring">
                  

              <!-- Start of Step's Metrics -->
              <div class="one-score-metric df fdr" v-for="(metric, j) in step.metrics"
                      v-bind:class="{
                      'roast-level-vertical': metric.scoring.type == 'roast-level-vertical',
                      'scale-horizontal': metric.scoring.type == 'scale-horizontal',
                      'scale-vertical': metric.scoring.type == 'scale-vertical',
                      'descriptors-vertical': metric.scoring.type == 'descriptors-vertical',
                    }">

                <!-- Step dropdown bar -->
               <!--  <div class="step-title df jcsb aic w100p" v-if="n === 0 && j === 0" 
                  v-bind:class="{
                    'current-step-title': currentStep === i
                  }" @click="toggleShowStep(i)">
                  <h2>{{step.name}}</h2>
                  <p v-if="showSteps.indexOf(i) > -1">▲</p>
                  <p v-else>▼</p>
                </div> -->


                <div class="df fdc f1"
                        v-if="(showSteps.indexOf(i) > -1) || showHorizontalView">
                  <!-- Metric Name -->
                  <div class="one-score-title"
                        v-if="(showSteps.indexOf(i) > -1) || showHorizontalView">
                    <p>
                      {{metric.name}}
                    </p>
                  </div> 


                  <!-- Metric Type: scale-horizontal -->
                  <div class="one-score-select df aic w100p jcsb"
                        v-if="((showSteps.indexOf(i) > -1) || showHorizontalView) && (metric.scoring.type == 'scale-horizontal')">


                    <div class="bars df w100p jcsb">
                      
                      <div class="increment increment-down" @click="changeScoreValue(-0.1, metric.scoring.from, metric.scoring.to, [n, i, j])">
                        <p>
                          -
                        </p>
                      </div>

                      <div class="df fdc f1">
                        <div class="rating-bar group-rating">
                          <div class="bar-fill group-bar-fill" v-bind:style="{
                            width: Math.random()*100 + '%',
                            opacity: showAverageScores ? 0.6 : 0
                          }"></div>
                        </div>
                        <div class="rating-bar my-rating">
                            <vue-slider v-if="loaded" :width="'100%'"
                              :max="metric.scoring.to"
                              :min="metric.scoring.from"
                              :interval="metric.scoring.increment"
                              :style="{
                                'height': '12px',
                                'padding': 0
                              }"
                              :railStyle="{
                                'height': '12px',
                                'borderRadius': 0,
                                'backgroundColor': $store.getters['AUTH.colorMode'] ? '#cdcdcd' : '#555'
                              }"
                              :stepStyle="{
                                'display': 'flex',
                                'backgroundColor': '#cacaca',
                                'borderRadius': 0,
                                'boxShadow': 'none',
                                'width': '1px'
                              }"
                              :processStyle="{
                                'backgroundColor': bagColor(coffee.bag),
                                'boxShadow': '#eeeeee',
                                'borderRadius': 0,
                              }"
                              :tooltipStyle="{
                                height: '25px',
                                width: '25px',
                                padding: 0,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                'backgroundColor': $store.getters['AUTH.colorMode'] ? 'rgba(255,255,255,.75)' : 'rgba(0,0,0,.75)',
                                'borderColor': $store.getters['AUTH.colorMode'] ? 'rgba(255,255,255,.75)' : 'rgba(0,0,0,.75)',
                                color: $store.getters['AUTH.colorMode'] ? '#444' : '#ddd',
                              }"
                              :tooltip-placement="'bottom'"
                              :dotOptions="{
                                tooltip: 'always'
                              }"
                              :dotStyle="{
                                display: 'none',
                                'borderRadius': 0,
                                'boxShadow': 'transparent',
                                'backgroundColor': 'transparent',
                                'borderColor': 'transparent',
                                'backgroundSize': 'contain',
                                'backgroundRepeat': 'no-repeat',
                                'backgroundPosition': 'center',
                                'height': '50px',
                                'width': '50px',
                                'top': '0',
                                'transform': 'translate(-17.5px, -65px)',
                              }"
                              :marks="staticMarksObject"
                              v-model="myScores[n].steps[i].metrics[j].score" />
                          <!-- <div class="bar-fill my-bar-fill" v-bind:style="{
                          width: Math.random()*100 + '%'
                        }"></div> -->
                        </div>
                        <!-- <div class="df jcsb w100p aic">
                          <a v-for="(score, j) in scoreCard">{{score}}</a>
                        </div> -->
                      </div>
                      <div class="increment increment-up"  @click="changeScoreValue(0.1, metric.scoring.from, metric.scoring.to, [n, i, j])">
                        <p>
                          +
                        </p>
                      </div>
                    </div>

                  </div> 
                </div>
                <!-- {{myScores}}     -->
                <!-- <input v-if="metric.scoring.scoreBox && ((showSteps.indexOf(i) > -1) || !showHorizontalView)" v-model="myScores[n].steps[i].metrics[j].score" class="metric-input" type="number" @input="checkInput($event, metric.scoring.from, metric.scoring.to, [n, i, j])" name="" :step="metric.scoring.increment" :min="metric.scoring.from" :max="metric.scoring.to"> -->



              </div>
              <!-- End of Step's Metrics -->




              <div class="descriptors df fdc" v-if="showSteps.indexOf(i) > -1">
                <h4>Descriptors</h4>
                <div class="df fdc">
                  <div class="word-cloud df aic jcc">
                    <vue-word-cloud
                        style="
                          height: 100px;
                          width: 100%;
                        "
                        :words="randomWordList()"
                        :color="'Grey'"
                        font-family="Roboto"
                      />
                  </div>
                  <div class="descriptor-list">
                    <p>
                      Earthy
                    </p>
                    <p>
                      Grape
                    </p>
                  </div>
                </div>
                <div class="df f100p jcsb aic descriptors-add">
                  <input placeholder="Add a descriptor" class="add-descriptor-input f1" type="text"/>
                  <button class="add-descriptor-button">Go</button>
                </div>
              </div>



            </div>
          </div>
          <!-- /// -->





        </div>
      </div>





    </div>

    <!-- ASK A QUESTION -->
    <!-- <div id="container"></div> -->

  </div>
</template>

<script>

import router from '../router'
import tasting_templates from '@/util/tasting_templates'

import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

// let generateScores = (template) => {
//   let _myScores = {}
// }

// let currentTemplate = tasting_templates['sca1']
// let myScores = generateScores(tasting_templates)

// import FlavorWheel from '@/components/FlavorWheel'
import VueWordCloud from 'vuewordcloud';

export default {
  name: 'Live',
  data () {
    return {
      showAverageScores: true,
      showHorizontalView: false,
      scoringMode: 'vertical',
      loaded: false,
      test: 7,
      loading: false,
      currentStep: 0,
      showSteps: [
        0
      ],
      liveQuestions: {
        askdjlksad: {
          time: 32424324324,
          question: 'What is coffee?',
          name: 'Mike',
          location: 'Toronto',
          plusOnes: {
            sdjf8932ujh9f3f: true
          }
        },
        askdjlksa34dd: {
          time: 3242432432455,
          question: 'Why do I often taste orange in coffee?',
          name: 'Jamie',
          location: 'Los Angeles',
          plusOnes: {
            sdjf8932ujh9f3f: true,
            sdjf8932ujh9ff33f: true,
          }
        },
        askdjlksa34dsdsdd: {
          time: 3242432432455,
          question: 'Where can I buy 87 point coffee?',
          name: 'Al',
          location: 'New York',
          plusOnes: {
            sdjf8932ujh9f3f: true,
            sdjf8932ujh9ff33f: true,
          }
        }
      },
      coffees: [
        {
          bag: 'blue',
          name: `Finca La Esmeralda`,
          description: `Castillo and Colombia varieties produced 1,600 meters above sea level and processed by Jonnes Urquina on his farm in Acevedo, Huila, Colombia. This coffee was imported by Collaborative Coffee Source.`
        },
        {
          bag: 'green',
          name: `Finca Twi'Ha`,
          description: `A mix of varieties--Pache Verde, Caturra, Criollo, and Bourbón--produced 1,550 to 1,920 meters above sea level under the management of father-and-son duo, Armando and Mauricio Gomez. The coffee is washed near Todos Santos in Huehuetenango, Guatemala. This coffee was imported by Regalia Coffee Roasters.`
        },
        {
          bag: 'yellow',
          name: `La Esperanza`,
          description: `Bourbón variety produced 1,550 to 1,920 meters above sea level and washed with the oversight of farm manager Aurelio Villatoro near Hoja Blanca in Huehuetenango, Guatemala. This coffee was imported by Panorama.`
        },
        {
          bag: 'orange',
          name: `Izote Java Natural`,
          description: `Java variety grown 1,150 to 1,300 meters above sea level and naturally processed on raised beds for nearly five weeks by Stuardo Coto and family in San Marcos, Guatemala. This coffee was imported by Regalia Coffee Roasters.`
        },
      ],
      cuppingSteps: [
        {
          name: 'Introduction',
          instruction: `Introducing our guest cupper Tony 'Tonx' Konecny` 
        },
        {
          name: 'Dry Fragrance',
          instruction: 'Grind your coffee to a medium grind and evaluate the dry fragrance.',
          scoring: true,
          scoreMetrics: [
            'Clarity',
            'Balance'
          ],
        },
        {
          name: 'Aroma #1',
          instruction: 'Boil water to 98 degrees Celsius. Pour over the grinds carefully. Wait 3 minutes, then begin to evaluate the wet aroma.',
          scoring: true,
          scoreMetrics: [
            'Clarity',
            'Body'
          ],
        },
        {
          name: 'Aroma #2',
          instruction: 'Break the crust, then evaluate the wet aroma again.',
          scoring: true,
          scoreMetrics: [
            'Clarity',
            'Body'
          ],
        },
        {
          name: 'Tasting',
          instruction: 'Evaluate the taste!',
          scoring: true,
          scoreMetrics: [
            'Taste',
            'Clarity',
            'Acidity',
            'Body'
          ],
        },
        {
          name: 'Discussion',
          instruction: `Let's talk about this cupping!`
        },
      ],
      tastingTemplate: [],
      myScores: [],
      staticMarksObject: this.marksObject(0, 6)
    }
  },
  props: [],
  components: {
    VueSlider,
    VueSlickCarousel,
    // FlavorWheel
    [VueWordCloud.name]: VueWordCloud,
  },
  methods: {
    flipColorMode () {
      this.$store.dispatch('AUTH.flipColorMode', {})
    },
    small () {
      let width = window.innerWidth
      return width < 1000
    },
    smaller () {
      let width = window.innerWidth
      console.log('width', width)
      return width < 610
    },
    videoHeight () {
      let height = window.innerHeight
      let width = window.innerWidth

      if (width < 1000) {
        return height / 3
      }

      return height / 2
    },
    videoWidth () {
      let height = window.innerHeight
      let width = window.innerWidth

      if (width < 1000) {
        return width - 45
      }
      return this.videoHeight*1.5
    },
    marksObject (from, to) {
      let interval = 0.25
      let object = {}
      // console.log('***', from, to)
      for (let i = from; to - i >= 0; i = i + interval) {
        // console.log('check', i)
        let height1 = 24;
        let height2 = 16;
        let height3 = 8;

        let display = 'none';

        let height = height3;
        if ((i % (interval * 4)) == 0) {
          height = height1
          display = 'block';
        } else if ((i % (interval * 2)) == 0) {
          height = height2
        }
        let translate = 12  * -1

        object[i] = {
          style: {
            width: '1px',
            height: height + 'px',
            display: 'block',
            backgroundColor: '#aaa',
            transform: 'translate(2px,' + translate + 'px)'
          },
          labelStyle: {
            // color: '#69c0ff',
            marginTop: '-42px',
            color: 'grey',
            display: display
          }
        }
        // console.log(object[i])
      }
      return object
      // {
      //   '6': {
      //     style: {
      //       width: '1px',
      //       height: '40px',
      //       display: 'block',
      //       backgroundColor: '#69c0ff',
      //       transform: 'translateY(-7.5px)'
      //     },
      //     labelStyle: {
      //       color: '#69c0ff'
      //     }
      //   }
      // }
    },
    myScoresSheet (template) {
      let sheet = []
      let coffees = this.coffees
      for (let n in coffees) {
        let coffee = {steps: []}
        for (let i in template.steps) {
          let step = {metrics: []}
          for (let j in template.steps[i].metrics) {
            let metric = {score: null}
            // let metric = {score: template.steps[i].metrics[j].from}
            step.metrics.push(metric)
          }
          coffee.steps.push(step)
        }
        sheet.push(coffee)
      }
      return sheet
    },
    metricScore (n, i, j) {
      let tastingTemplate = this.tastingTemplate
      if (tastingTemplate.steps[i]) {
        if (tastingTemplate.steps[i].metrics[j]) {
          if (tastingTemplate.steps[i].metrics[j].score) {
            if (tastingTemplate.steps[i].metrics[j].score[n]) {
              return tastingTemplate.steps[i].metrics[j].score[n]
            }
          }
        }
      }
      return null
    },
    coffeeScore (n) {
      let myScores = this.myScores
      let totalScore = 0

      if (myScores[n]) {
        for (let i in myScores[n].steps) {
          for (let j in myScores[n].steps[i].metrics) {
            if (myScores[n].steps[i].metrics[j].score) {
                totalScore = totalScore + myScores[n].steps[i].metrics[j].score
            }
          }
        }
      }

      return totalScore.toFixed(1)
    },
    randomWordList () {
      let array = []
      let words = [
        'acidity',
        'aftertaste',
        'body',
        'aroma',
        'flavor',
        'region',
        'orange',
        'peach',
        'bergamot',
        'berry',
      ]
      let max = words.length
      let randomLength = Math.floor(max * Math.random())
      for (let i = 0; i < randomLength; i = i + 1) {
        let randomWord = Math.floor(max * Math.random())
        randomWord = words[randomWord]
        let randomNumber = Math.ceil(Math.random() * 20)
        array.push([
          randomWord,
          randomNumber
        ])
      }
      return array
      // [['romance', 19], ['horror', 3], ['fantasy', 7], ['adventure', 3]]
    },
    setCurrentStep (i) {
      this.currentStep = i
    },
    changeScoreValue(amount, min, max, coords) {
      let n = coords[0]
      let i = coords[1]
      let j = coords[2]
      let currentScore = this.myScores[n].steps[i].metrics[j].score || 0
      let newScore = currentScore + amount
      newScore = Math.round(newScore * 10) / 10
      let event = {target: {value: newScore}}
      this.checkInput(event, min, max, coords)
    },
    checkInput (event, min, max, coords) {
      let val = event.target.value
      let n = coords[0]
      let i = coords[1]
      let j = coords[2]

      if (val == '') {
        this.myScores[n].steps[i].metrics[j].score = null
      } else if (val < min) {
        this.myScores[n].steps[i].metrics[j].score = min
      } else if (val >= max) {
        this.myScores[n].steps[i].metrics[j].score = max
      } else {
        this.myScores[n].steps[i].metrics[j].score = val
      }
    },
    toggleShowStep (i) {
      if (this.showSteps.indexOf(i) > -1) {
        let showSteps = this.showSteps
        let index = showSteps.indexOf(i)
        showSteps.splice(index, 1)
        this.showSteps = showSteps
      } else {
        let showSteps = this.showSteps
        showSteps.push(i)
        this.showSteps = showSteps
      }
    },
    bagColor (name) {
      switch(name) {
        case 'blue':
          return '#0366bf'
          break;
        case 'green':
          return '#01886a'
          break;
        case 'yellow':
          return '#f7c132'
          break;
        case 'orange':
          return '#fc642c'
          break;
        default:
          return '#ddd' 
          // code block
      }
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
    console.log('* Live page created')
    // this.tastingTemplate = tasting_templates['sca1']
    this.tastingTemplate = tasting_templates['scott_ryan']
    this.myScores = this.myScoresSheet(this.tastingTemplate)
    this.loaded = true
    // this.loadCharts()

    let reload = () => {
      this.$forceUpdate();
    }

    window.onresize = reload
  }
}
</script>

<style scoped lang="scss">
  @import "../styles/settings.scss";

  $orange: orange;
  $orange2: #de9c25;

  h1 {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  h2 {
    font-weight: 600;
    font-size: 16px;
    /*margin-bottom: 10px;*/
  }

  .live-cupping-video {
    height: calc(50vh - 30px);
    width: calc((50vh - 30px) * 1.5);
    min-width: calc((50vh - 30px) * 1.5);
  }

  .live-cupping-top {
    /*margin-left: 15px;*/
    height: 100%;
  }

  .live-wrapper {
    background-color: #292929;
    padding: 15px;
    /*padding-top: 30px;*/
    /*padding-top: 0px;*/
  }
  .inverted-colors {
    .live-wrapper {
      background-color: #eaeaea;
    }
    .live-cupping-questions {
      background: $color-white;
    }
    .ask-a-question-button {
      background-color: transparent;
      border: 1px solid #999;
    }
    .ask-a-question-input {
      border-color: #999;
    }
  }
  .cupping-top {
    /*margin-bottom: 15px;*/
    /*background-color: #1d1d1d;*/
    height: 60px;
    width: auto;
    width: 100%;
  }
  .live-splash {
    width: 100%;
    margin-bottom: 4px;
    /*background-color: #3a3a3a;*/
    /*max-width: 720px;*/
  }
  .cupping-steps {
    padding: 5px;
    orphans: 0;
    width: 30%;
    min-width: 220px;
  }
  .cupping-step-name {
    width: 150px;
  }
  .current-step {
    a, p {
      color: $orange;
    }
  }
  .one-coffee {
    flex-direction: column;
    width: 24%;
  }
  .one-coffee-bag {
    position: relative;
    height: 35px;
    text-transform: capitalize;
    width: 100%;
    text-align: center;
    padding-right: 15px;
    padding-left: 15px;

    span {
      /*position: absolute;*/
      /*right: 20px;*/
    }
  }
  .blue-bag {
    $bag-blue: #0366bf;
    .one-coffee-bag {
      background-color: $bag-blue;
    }
    .bar-fill {
      background-color: $bag-blue;
    }
  }
  .green-bag {
    $bag-green: #01886a;
    .one-coffee-bag {
      background-color: $bag-green;
    }
    .bar-fill {
      background-color: $bag-green;
    }
  }
  .yellow-bag {
    $bag-yellow: #f7c132;
    .one-coffee-bag {
      background-color: $bag-yellow;
    }
    .bar-fill {
      background-color: $bag-yellow;
    }
  }
  .orange-bag {
    $bag-orange: #fc642c;
    .one-coffee-bag {
      background-color: $bag-orange;
    }
    .bar-fill {
      background-color: $bag-orange;
    }
  }
  .group-bar-fill {
    opacity: 0.6;
  }
  .coffees {
    position: relative;
  }
  .coffee-my-things {
  }
  .cupping-step1 {
    margin-bottom: 8px;
    /*width: 286px;*/
    /*background-color: #333;*/

    &:first-child {
      margin-bottom: 0;
    }
  }
  .one-score-metric {
    margin-bottom: 12px;
  }
  .cupping-step {
    display: flex;
    /*margin-bottom: 10px;*/
    color: white;
    font-size: 16px;
    padding: 15px;
    padding-top: 5px;
    /*margin-top: 15px;*/
    /*padding-top: 65px;*/
    /*margin-bottom: -25px;*/
    flex-wrap: wrap;

    &:last-child {
      margin-bottom: 0;
    }
  }
  .step-title {
    cursor: pointer;
    height: 50px;
    position: absolute;
    width: 100%;
    left: 0;
    transform: translateY(-60px);
    padding-left: 15px;
    padding-right: 15px;
    background-color: #222;
  }
  .current-step-title {
    background-color: $orange2;
  }
  .one-score-select {

  }
  .metric-input {
    background-color: grey;
    font-size: 24px;
    color: white;
    text-align: center;
    margin-left: 20px;
    width: 50px;
    height: 50px;
    padding: 4px;
    /* Chrome, Safari, Edge, Opera */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    /*input[type=number] {*/
      -moz-appearance: textfield;
    /*}*/
  }
  .live-cupping-questions {
    background-color: #3a3a3a;
    /*height: 100%;*/
    margin-left: 15px;
    /*margin-top: 15px;*/
    /*margin-bottom: 15px;*/
    padding: 15px;
    /*padding-left: 30px;*/
    /*border-left: 1px solid #999;*/
    width: 70%;
  }
  .live-cupping-top-below {
    /*margin-top: 10px;*/
  }
  .ask-a-question {
    margin-top: 20px;
  }
  input {
    background-color: white;
    padding: 10px;
    font-size: 14px;
    /*margin-bottom: 20px;*/
  }

  .increment {
    button {
      width: 30px;
      height: 30px;
      background-color: #666;
      /*padding: 10px;*/
      font-size: 40px;
      color: #bbb;
      border-radius: 10px;
    }
    p {
      width: 20px;
      min-width: 20px;
      display: block;
      font-size: 22px !important;
      cursor: pointer;
      font-weight: 400 !important;    
    }
  }
  .increment-down {
    margin-right: 2px;
    p {
      text-align: left !important;
    }
  }
  .increment-up {
    margin-left: 2px;
    p {
      text-align: right !important;
    }
  }
  .live-qupping-questions-list {
    overflow-y: auto;
    /*height: 100%;*/
  }
  .question-plus-one {
    cursor: pointer;
    margin-left: 8px; 
    color: #676767;

    &:hover {
      color: #0366bf;
    }
  }
  #container {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
  }
  .rating-bar {
    height: 12px;
  }
  .my-rating {
    height: unset;
  }
  .bar-fill {
    height: 100%;
    background-color: grey;
    transition: width 1.25s ease;
  }
  .descriptors {
    width: 100%;
    margin-top: 4px;
    & > h4 {
      font-weight: 600;
      margin-bottom: 10px;
    }
    .descriptor-list {
      p {
        font-size: 16px;
        margin-bottom: 10px;
      }
    }
    margin-bottom: 50px;
  }
  .step-description {
    /*margin-bottom: 30px;*/
    /*background-color: #333;*/
    /*padding: 10px;*/
    /*margin-top: 20px;*/

    h2 {
      font-size: 24px;
      font-weight: 600;
    }
    p {
      /*margin-top: 10px;*/
      /*text-align: right;*/
      font-size: 18px;
    }
  }
  .word-cloud {
    margin-bottom: 20px;
  }
  $scoring-box-size: 300px;
  .horizontal-scoring-view {
    .smaller-step {
      max-width: $scoring-box-size/2 + 3.5px !important;
    }
    .step-title {
      display: none;
    }
    & > .coffees {
    flex-direction: column;
      & > .one-coffee {
        width: 100%;
        display: flex;
        flex-direction: row;
        height: $scoring-box-size;
        margin-bottom: 40px;
        height: unset;

        .one-coffee-bag {
          width: 200px;
        }

        &:last-child {
          margin-bottom: 0;
        }

        .coffee-my-things {
          display: flex;
          flex-direction: row;
          flex: 1;

          .cupping-step {
            margin-top: 0;
            flex: 1;
            padding: 10px;
            /*height: $scoring-box-size;*/
            /*max-width: $scoring-box-size + 7px;*/
            border: 1px solid #555;

            .descriptors {
              margin-bottom: 0;
            }

            .word-cloud, .descriptor-list, .descriptors-add {
              max-width: 305px;
            }

            .one-score-metric {
              max-width: $scoring-box-size;
              margin-right: 15px;
            }
          }
        }
      }
    }
  }
  $base-font-size: 16px;
  .scale-horizontal {
    width: 100%;

    p {
      font-size: $base-font-size;
      font-weight: 600;
      text-align: left;
    }
  }
  .scale-vertical {
    width: 20%;
    height: 50%;
    p {
      font-size: $base-font-size;
    }
  }
  .descriptors-vertical {
    width: 60%;
    p {
      font-size: $base-font-size;
    }
  }
  .roast-level-vertical {
    p {
      font-size: $base-font-size;
      font-weight: 600;
      text-align: left;
    }
  }
  .one-score-title {
    pointer-events: none;
    text-align: center; 
    margin-bottom: 18px;
    z-index: 10;
    margin-top: 36px;

    p {
      font-size: 12px;
    }
  }
  .one-score-metric:first-child {
    .one-score-title {
      margin-top: 6px;
    }
  }
  .sheet-option {
    margin-bottom: 4px;
    margin-left: 24px;

    &:first-child {
      margin-left: 0;
    }
    input {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
    p {
      font-size: 12px;
    }
  }
  .cupping-with {
    /*margin-bottom: 15px;*/
  }
  .step-description {
    font-size: 14px;
  }
  h4 {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 15px;
  }
  .viewer-question-text {
    font-size: 14px;
    margin-bottom: 8px;
  }
  .icon {
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
  .ask-a-question-button {
    height: 36px;
    padding: 0 30px;
    background-color: #555;
    border-radius: 10px;
    margin-left: 15px;
  }
  .ask-a-question-input {
    box-sizing: border-box;
    border: 1px solid #888;
    background-color: transparent;
    color: #ddd;
  }

  @media (max-width: 1000px) {
    .live-cupping-video {
      height: calc(33.33vh - 30px);
      width: 100%;
      min-width: 100%;
    }
    .live-splash {
      flex-direction: column;
    }
    .live-cupping-top {
      width: 100%;
    }
    .live-cupping-top-below {
      width: 100%;
    }
    .live-cupping-questions {
      width: 100%;
      margin-left: 0;
      margin-top: 15px;
    }
    .coffee-my-things {
      padding-left: 20px;
      padding-right: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Live3.vue